import React from "react";
import InputMask from "react-input-mask";
import { FieldRendererProps } from "../types";
import { StyledFormControl, ErrorMessage } from "../styles";
import { TipoFormulario } from "../../../services/constantes";

export const MaskedFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <InputMask
      mask={campo.mascara!}
      value={getFieldValue(campo.nome)}
      onChange={(e: any) => {
        handleInputChange(campo.nome, campo.tudoMaiusculo ? e.target.value.toUpperCase() : e.target.value);
      }}
      onBlur={() => handleBlur(campo)}
      onKeyUp={(e: any) => {
        campo.onCampoDigitar && campo.onCampoDigitar(e.target.value);
      }}
      readOnly={modo === TipoFormulario.tpVisualizacao}
      maskPlaceholder={null}
      alwaysShowMask={true}
    >
      {(inputProps: any) => (
        <StyledFormControl
          {...inputProps}
          type={campo.tipo}
          required={campo.required}
          hasError={!!errors[campo.nome]}
        />
      )}
    </InputMask>
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
